export default __webpack_public_path__ + "static/media/warning-alert.980a3e64.svg";